import { createContext, useContext, useState, useCallback } from 'react';
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import tr from './locales/tr.json';
import el from './locales/el.json';
import ro from './locales/ro.json';
import pt from './locales/pt.json';

const TRANSLATIONS = { fr, en, es, it, nl, tr, el, ro, pt };

export const LANGUAGES = [
  { code: 'fr', label: 'Français',   flag: '🇫🇷' },
  { code: 'en', label: 'English',    flag: '🇬🇧' },
  { code: 'es', label: 'Español',    flag: '🇪🇸' },
  { code: 'pt', label: 'Português',  flag: '🇧🇷' },
  { code: 'it', label: 'Italiano',   flag: '🇮🇹' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'tr', label: 'Türkçe',     flag: '🇹🇷' },
  { code: 'el', label: 'Ελληνικά',   flag: '🇬🇷' },
  { code: 'ro', label: 'Română',     flag: '🇷🇴' },
];

const LangContext = createContext(null);


const SUPPORTED = new Set(LANGUAGES.map(l => l.code));

function detectLang() {
  const saved = localStorage.getItem('app_lang');
  if (saved && SUPPORTED.has(saved)) return saved;
  for (const pref of navigator.languages || [navigator.language]) {
    const code = pref.slice(0, 2).toLowerCase();
    if (SUPPORTED.has(code)) return code;
  }
  return 'en';
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  const setLang = useCallback((code) => {
    localStorage.setItem('app_lang', code);
    setLangState(code);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const keys = key.split('.');
      const resolve = (dict) => keys.reduce((o, k) => (o != null ? o[k] : undefined), dict);
      let val = resolve(TRANSLATIONS[lang]) ?? resolve(TRANSLATIONS.fr) ?? key;
      if (typeof val !== 'string') return key;
      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          val = val.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v));
        });
      }
      return val;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) {
    const t = (key) => key;
    return { lang: 'fr', setLang: () => {}, t };
  }
  return ctx;
}
